import "materialize-css";

const MaterializeTabsDirective = function ($timeout) {
    return function (scope, element, attrs) {
        // Delay tab initialization until angular digest has completed.
        // without '$timeout', 'Cannot read property 'left' of undefined' exceptions are thrown by Materialize js library
        // as this may get called before digest cycle is complete.
        $timeout(function () {
            element.tabs();
        });
    };
};

MaterializeTabsDirective.$inject = ["$timeout"];

export { MaterializeTabsDirective };